import { render, staticRenderFns } from "./search-modal-customer-collection.vue?vue&type=template&id=201677fb&scoped=true&"
import script from "./search-modal-customer-collection.vue?vue&type=script&lang=ts&"
export * from "./search-modal-customer-collection.vue?vue&type=script&lang=ts&"
import style0 from "./search-modal-customer-collection.vue?vue&type=style&index=0&id=201677fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201677fb",
  null
  
)

export default component.exports